import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=c7f82c56&scoped=true&"
import script from "./exam.vue?vue&type=script&lang=js&"
export * from "./exam.vue?vue&type=script&lang=js&"
import style0 from "./exam.vue?vue&type=style&index=0&id=c7f82c56&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7f82c56",
  null
  
)

export default component.exports